import React from "react";
import {ConversationMessageMediaItemProps} from "./ConversationMessageMedia";
import {FilePdfFilled, RightCircleOutlined} from "@ant-design/icons";

const ConversationMediaPDF = ({ mediaItem }: { mediaItem: ConversationMessageMediaItemProps }) => {
    return <div className="message-bubble-thumb-button-container" onClick={() => window.open(mediaItem.url)}>
        <div className="message-bubble-thumb-button">
            <FilePdfFilled width={48} height={48} />
            <div>PDF</div>
        </div>
        <RightCircleOutlined width={48} height={48} />
    </div>
}

export default ConversationMediaPDF;